<template>
  <div style="height: 100%; width: 100%">
    <q-table
      v-if="selection == 'multiple'"
      ref="table"
      style="width: 100%"
      :data="data"
      :columns="columns"
      :separator="separator"
      :rows-per-page-options="[5,10]"
      :pagination.sync="pagination"
      :flat="flat"
      :grid="grid"
      :filter="filter"
      :filter-method="customFilter"
      virtual-scroll
      row-key="id"
      @row-click="handleClick"
      @row-dblclick="handleDoubleClick"
      :selected.sync="selected"
      :selection="selection"
      @selection="onSelection"
      :class="{
        sticky: sticky,
      }"
    >
      <!-- TODO: Needs quite a bit of work to get working -->
      <template v-if="updateBody" v-slot:body="props">
        <slot :name="`body`" v-bind:props="props">
          <q-tr
            @click="handleClick(null, props.row)"
            @dblclick="handleDoubleClick(null, props.row)"
            :props="props"
          >
            <q-td auto-width>
              <q-checkbox v-model="props.selected" />
            </q-td>
            <slot
              v-for="column in props.cols"
              :name="`body-cell-${column.name}`"
              v-bind:props="props"
            >
              <q-td :key="column.name" :props="props">
                {{ column.value }}
              </q-td>
            </slot>
          </q-tr>
        </slot>
      </template>
      <template
        v-else
        v-for="column in columns"
        v-slot:[`body-cell-${column.name}`]="props"
      >
        <slot :name="`body-cell-${column.name}`" v-bind:props="props">
          <q-td :props="props"> {{ props.value }} </q-td>
        </slot>
      </template>
    </q-table>
    <q-table
      v-else
      ref="table"
      style="width: 100%"
      :data="data"
      :columns="columns"
      :separator="separator"
      :rows-per-page-options="[0]"
      :pagination.sync="pagination"
      :flat="flat"
      :grid="grid"
      :filter="filter"
      :filter-method="customFilter"
      virtual-scroll
      row-key="id"
      @row-click="handleClick"
      @row-dblclick="handleDoubleClick"
      :selected.sync="selected"
      :class="{
        sticky: sticky,
      }"
    >
      <template v-if="updateBody" v-slot:body="props">
        <slot :name="`body`" v-bind:props="props">
          <q-tr
            @click="handleClick(null, props.row)"
            @dblclick="handleDoubleClick(null, props.row)"
            :props="props"
          >
            <slot
              v-for="column in props.cols"
              :name="`body-cell-${column.name}`"
              v-bind:props="props"
            >
              <q-td :key="column.name" :props="props">
                {{ column.value }}
              </q-td>
            </slot>
          </q-tr>
        </slot>
      </template>
      <template
        v-else
        v-for="column in columns"
        v-slot:[`body-cell-${column.name}`]="props"
      >
        <slot :name="`body-cell-${column.name}`" v-bind:props="props">
          <q-td :props="props">
            {{ props.value }}
          </q-td>
        </slot>
      </template>
    </q-table>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import moment from "moment";

  export default {
    components: {},
    computed: {
      ...mapGetters([]),
    },
    props: {
      columns: Array,
      data: Array,
      flat: {
        type: Boolean,
        default: false,
      },
      separator: {
        type: String,
        default: "horizontal",
      },
      sticky: {
        type: Boolean,
        default: true,
      },
      grid: {
        type: Boolean,
        default: false,
      },
      filter: {
        default: "",
      },
      externalFilter: {
        type: Function,
      },
      selection: {
        type: String,
        default: "single",
      },
      updateBody: {
        type: Boolean,
        default: false,
      },
      myPagination: Object,
    },
    watch: {
      myPagination: function(val) {
        this.pagination = val;
        this.$emit('myPagination', val)
      },
      data: function(val) {
        let space = this.$refs.table.$el.querySelector(".q-table__middle").scrollHeight - 48;
        let rows = Math.floor(space / 48);
        this.pagination.rowsPerPage = rows;
      },
      pagination: function(val) {
        //console.log(val);
      }
    },
    data: () => ({
      pagination: {
        rowsPerPage: 0,
      },
      selected: [],
      lastIndex: null,
    }),
    mounted() {
      let _this = this;
      let tableElement = this.$refs.table.$el;

      const resizeObserver = new ResizeObserver((entries) => {
          let headerHeight = tableElement.querySelector(".q-table__middle").querySelector("thead").scrollHeight + 1;
          let rowHeight = 48;
          let space = entries[0].contentBoxSize[0].blockSize - headerHeight;
          let rows = Math.floor(space / rowHeight);
          _this.$nextTick(() => {
            _this.pagination.rowsPerPage = rows;
            if (_this.$refs.table) {
              _this.$refs.table.setPagination(_this.pagination);
            }
          })
      });

      resizeObserver.observe(this.$refs.table.$el.querySelector(".q-table__middle"));

      if (this.myPagination) {
        this.pagination = this.myPagination
      }
    },
    methods: {
      handleClick(e, row) {
        this.selected = [row];
        this.$emit("rowSelected", row);
      },
      handleDoubleClick(e, row) {
        this.$emit("rowDoubleClick", row);
      },
      customFilter(rows, terms, cols) {
        // If terms is a straight string then search as normal Otherwise use externalFilter()
        if (typeof terms == "string") {
          return rows.filter((row) => {
            let matchFound = false;
            for (let i = 0; i < cols.length; i++) {
              let val = `${row[cols[i].field]}`.toLowerCase();
              matchFound = val.toLowerCase().indexOf(terms.toLowerCase()) > -1;

              if (matchFound == true) {
                i = cols.length;
              }
            }
            return matchFound;
          });
        } else {
          // External Filter is sent through as a Property
          return this.externalFilter(rows, terms, cols);
        }
      },
      onSelection({ rows, added }) {
        let evt = window.event;

        if (rows.length === 0 || this.$refs.table === void 0) {
          return;
        }

        const row = rows[0];
        const filteredSortedRows = this.$refs.table.filteredSortedRows;
        const rowIndex = filteredSortedRows.indexOf(row);
        const lastIndex = this.lastIndex;

        this.lastIndex = rowIndex;
        document.getSelection().removeAllRanges();

        if (this.$q.platform.is.mobile === true) {
          evt = { ctrlKey: true };
        } else if (
          evt !== Object(evt) ||
          (evt.shiftKey !== true && evt.ctrlKey !== true)
        ) {
          this.selected = added === true ? rows : [];

          return;
        }

        const operateSelection =
          added === true
            ? (selRow) => {
                const selectedIndex = this.selected.indexOf(selRow);
                if (selectedIndex === -1) {
                  this.selected = this.selected.concat(selRow);
                }
              }
            : (selRow) => {
                const selectedIndex = this.selected.indexOf(selRow);
                if (selectedIndex > -1) {
                  this.selected = this.selected
                    .slice(0, selectedIndex)
                    .concat(this.selected.slice(selectedIndex + 1));
                }
              };
        if (lastIndex === null || evt.shiftKey !== true) {
          operateSelection(row);

          return;
        }
        const from = lastIndex < rowIndex ? lastIndex : rowIndex;
        const to = lastIndex < rowIndex ? rowIndex : lastIndex;

        for (let i = from; i <= to; i += 1) {
          operateSelection(filteredSortedRows[i]);
        }
        let test = JSON.parse(JSON.stringify(this.selected));
        setTimeout(() => {
          this.selected = test;
        }, 50);
      },
    },
  };
</script>

<style lang="scss">
  .sticky {
    height: 100% !important;

    .q-table__top,
    .q-table__bottom,
    thead tr:first-child th {
      /* bg color is important for th; just specify one */
      background-color: white;
    }

    thead tr th {
      position: sticky;
      z-index: 1;
    }

    thead tr:first-child th {
      top: 0;
    }

    /* this is when the loading indicator appears */
    &.q-table--loading thead tr:last-child th {
      top: 48px;
      /* height of all previous header rows */
    }
  }
</style>
